<button
  pButton
  class="m-button {{ type }} {{ styleClass }}"
  [disabled]="disabled || loading"
  [style]="style"
  [label]="label"
  [icon]="icon"
  [loading]="loading"
  [loadingIcon]="loadingIcon || 'pi pi-spin pi-spinner'">
  <ng-content></ng-content>
</button>
